export default (): { showCursor: () => void; hideCursor: () => void } => {
  return {
    showCursor: () => mp.invoke("focus", true),
    hideCursor: () => mp.invoke("focus", false),
  };
};
